import { getManageIdPasswordLink } from 'Foundation/Configurations/GlobalConfiguration';

export default function BLFooterLinks() {
  return (
    <>
      <a
        rel="noopener noreferrer"
        href={getManageIdPasswordLink(true)}
        target="_blank"
        title="Manage your ID and password for this site"
      >
        Manage ID &amp; password
      </a>
      &nbsp;|&nbsp;
      <a
        rel="noopener noreferrer"
        href="https://www.libertymutualgroup.com/about-lm/corporate-information/privacy-policy"
        target="_blank"
        title="Liberty Mutual Privacy Policy"
      >
        Privacy policy
      </a>
      &nbsp;|&nbsp;
      <a
        rel="noopener noreferrer"
        href="https://privacyportal-cdn.onetrust.com/dsarwebform/50577d86-8d39-4310-9583-33e6d3da8e17/72f160d9-f2c3-4918-bb13-13507fe371ed.html"
        target="_blank"
        title="Make a personal data request"
      >
        Personal data request
      </a>
      &nbsp;|&nbsp;
      <a
        rel="noopener noreferrer"
        href="/Terms-and-conditions"
        target="_blank"
        title="View this site's terms and conditions"
      >
        Terms and conditions
      </a>
      &nbsp;|&nbsp;
      <a rel="noopener noreferrer" href="/Help" target="_blank" title="Help">
        Help
      </a>
    </>
  );
}
